import request from "@/api/request";
// 返回data.data
const apiPost = function (url, param) {
  return request.apiPost(url, param);
};

// 返回data
const apiPost2 = function (url, param) {
  return request.apiPost2(url, param);
};

export default {
  apiPost,
  apiPost2,
};
